import { render, staticRenderFns } from "./New.vue?vue&type=template&id=9a405608&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
import style0 from "./New.vue?vue&type=style&index=0&id=9a405608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a405608",
  null
  
)

export default component.exports